import { tagGQLFields } from '../post/tag.fields.js';
const BASIC_HIGHLIGHTED_TAG_FIELDS = {
    tag: 'basic',
};
const ALL_HIGHLIGHTED_TAG_FIELDS = {
    tag: 'all',
};
export function highlightedTagGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_HIGHLIGHTED_TAG_FIELDS;
    if (fields === 'all')
        fields = ALL_HIGHLIGHTED_TAG_FIELDS;
    return `
    indent
    text
    type
    ${fields.tag
        ? `
      tag {
        ${tagGQLFields(fields.tag)}
      }`
        : ``}
  `;
}
//# sourceMappingURL=highlightedTag.fields.js.map